var map = {
	"./404.json": 4438,
	"./account.json": 152,
	"./blockbuster.json": 4698,
	"./cinema.json": 2449,
	"./faq.json": 5257,
	"./footer.json": 9170,
	"./get-started.json": 702,
	"./header.json": 6535,
	"./index.json": 4773,
	"./info.json": 5448,
	"./privacy.json": 2542,
	"./schools.json": 5092,
	"./sign-in.json": 7754,
	"./subreader-ambassadoer.json": 8777,
	"./subscription.json": 476,
	"./terms.json": 332
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8896;